import Container from '@material-ui/core/Container';
import { createStyles, makeStyles } from '@material-ui/core/styles';
// import TextField from '@material-ui/core/TextField';
import React from 'react';
import {
  type AfterPageProps,
  createApiClient,
  createInitialPropsRedirectToLogin,
  makeAfterComponent,
  wrapLayout,
} from '../../@sprinx/react-after-razzle';
import InfoLayout from '../../layouts/InfoLayout/InfoLayout';
import commonThingsToLoad from '../../api/commonThingsToLoad';

export type CareerPageProps = AfterPageProps;
export type CareerPageClassNameKey = 'root';

const useStyles = makeStyles(() =>
  createStyles<CareerPageClassNameKey, {}>({
    root: {},
  }),
);

const CareerPage: React.FC<CareerPageProps> = () => {
  const classes = useStyles();

  return (
    <>
      <Container>
        <div className={classes.root}>
          <h1>Kariéra</h1>

          <h2>Pracovní nabídky a volné pozice</h2>
        </div>
      </Container>
    </>
  );
};

CareerPage.displayName = 'CareerPage';

export default makeAfterComponent(
  wrapLayout<CareerPageProps>(CareerPage, InfoLayout),
  async ({ match, initialAppProps }) => {
    try {
      if (initialAppProps) {
        const appProps = initialAppProps;
        const apiClient = createApiClient({ accessToken: appProps.auth?.accessToken });
        const commonThings = await Promise.all(commonThingsToLoad.promises({ apiClient }));
        appProps.propagateToState({
          ...commonThingsToLoad.toRegister(commonThings),
        });
      }
      return {};
    } catch (error) {
      if (error.response?.status === 401) {
        return createInitialPropsRedirectToLogin({ match });
      }
      return { error };
    }
  },
);
